import { render, staticRenderFns } from "./AutocompleteGeolocation.vue?vue&type=template&id=56ed3d27&lang=pug&"
import script from "./AutocompleteGeolocation.vue?vue&type=script&lang=js&"
export * from "./AutocompleteGeolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports